'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useRef, useState } from 'react';
import ViverseButton from '@/components/ViverseButton';
import ViverseInputOTP from '@/components/ViverseInputOTP';
import { redirectAfterPasscodeValidation } from '@/server/lib/passcode';
const PASSCODE_LENGTH = 6;
interface SpacePasscodeProps {
  roomId: string;
  roomTitle?: string;
  htcAuthKey?: string;
}
export default function SpacePasscode(t0) {
  const $ = _c(32);
  const {
    roomId,
    roomTitle: t1,
    htcAuthKey: t2
  } = t0;
  const roomTitle = t1 === undefined ? "" : t1;
  const htcAuthKey = t2 === undefined ? "" : t2;
  const t = useTranslations();
  const [passcode, setPasscode] = useState("");
  const [hasError, setHasError] = useState(false);
  const inputRef = useRef(null);
  let t3;
  if ($[0] !== htcAuthKey || $[1] !== roomId) {
    t3 = async formData => {
      const code = formData.get("passcode")?.toString() ?? "";
      const isInvalid = await redirectAfterPasscodeValidation(code, roomId, htcAuthKey);
      if (!isInvalid) {
        setPasscode("");
        setHasError(true);
        inputRef.current?.focus();
      }
    };
    $[0] = htcAuthKey;
    $[1] = roomId;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handlePasscode = t3;
  let t4;
  if ($[3] !== t) {
    t4 = t("space-passcode-page.intro-topic");
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <h2 className="mb-2 text-lg text-gray-300">{t4}</h2>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== roomTitle) {
    t6 = <p className="mb-2 text-xl font-bold text-white">{roomTitle}</p>;
    $[7] = roomTitle;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t) {
    t7 = t("space-passcode-page.intro-desc");
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = <p className="mb-8 max-w-md text-xs text-gray-400">{t7}</p>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== hasError || $[14] !== passcode) {
    t9 = <div className="mb-10"><ViverseInputOTP ref={inputRef} name="passcode" maxLength={PASSCODE_LENGTH} value={passcode} onChange={setPasscode} hasError={hasError} defaultHidden={true} autoFocus={true} /></div>;
    $[13] = hasError;
    $[14] = passcode;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== hasError || $[17] !== t) {
    t10 = hasError && <p className="mb-4 text-sm text-[#cb4e4b]">{t("space-passcode-page.invalid")}</p>;
    $[16] = hasError;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = passcode.length !== PASSCODE_LENGTH;
  let t12;
  if ($[19] !== t) {
    t12 = t("space-passcode-page.join");
    $[19] = t;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <ViverseButton type="submit" disabled={t11}>{t12}</ViverseButton>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== handlePasscode || $[25] !== t10 || $[26] !== t13 || $[27] !== t5 || $[28] !== t6 || $[29] !== t8 || $[30] !== t9) {
    t14 = <form action={handlePasscode} className="flex h-svh w-full flex-col items-center justify-center text-base">{t5}{t6}{t8}{t9}{t10}{t13}</form>;
    $[24] = handlePasscode;
    $[25] = t10;
    $[26] = t13;
    $[27] = t5;
    $[28] = t6;
    $[29] = t8;
    $[30] = t9;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
}